var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 101,
  height: 100,
  fill: "none",
  viewBox: "0 0 101 100"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  x: 0.5,
  fill: "#FC1F4B",
  fillOpacity: 0.08,
  rx: 50
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FC1F4B",
  d: "m39.25 65.625 11.25-11.25 11.25 11.25 4.375-4.375L54.875 50l11.25-11.25-4.375-4.375-11.25 11.25-11.25-11.25-4.375 4.375L46.125 50l-11.25 11.25zM50.5 81.25q-6.484 0-12.187-2.46-5.704-2.463-9.922-6.68-4.22-4.22-6.68-9.922Q19.25 56.484 19.25 50t2.46-12.187 6.68-9.922q4.219-4.22 9.923-6.68T50.5 18.75q6.484 0 12.188 2.46 5.703 2.462 9.921 6.68 4.22 4.219 6.68 9.923T81.75 50q0 6.484-2.46 12.188-2.463 5.703-6.68 9.921-4.22 4.22-9.922 6.68-5.704 2.46-12.188 2.461"
})));
export default SvgError;